import { createTheme } from "@mui/material/styles";
import { DEFAULT_SCHEME } from "../constants/colorSchemes";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: DEFAULT_SCHEME.color,
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: 40,
            padding: "0 8px",
            borderRadius: "8px",
            fontSize: "14px",
          },
          "& input": {
            fontSize: "14px",
          },
        },
      },
    },

    MuiPickersLayout: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          border: "1px solid #ddd",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        },
      },
    },

    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: "var(--color-accent-active)",
        },
      },
    },

    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          borderRadius: "8px",
        },
        today: {
          border: "1px solid var(--color-accent-active)",
        },
        selected: {
          backgroundColor: "var(--color-accent-active) !important",
          color: "#fff !important",
        },
      },
    },

    // MuiMultiSectionDigitalClock: {
    //   styleOverrides: {
    //     root: {
    //       width: 150,
    //     },
    //   },
    // },

    MuiMultiSectionDigitalClockSectionItem: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
        selected: {
          backgroundColor: "var(--color-accent-active) !important",
          color: "#fff !important",
          borderRadius: "6px",
        },
      },
    },

    MuiClockPointer: {
      styleOverrides: {
        thumb: {
          backgroundColor: "var(--color-accent-active)",
          borderColor: "var(--color-accent-active)",
        },
        pointer: {
          backgroundColor: "var(--color-accent-active)",
        },
      },
    },

    MuiPickersClockNumber: {
      styleOverrides: {
        selected: {
          backgroundColor: "var(--color-accent-active) !important",
          color: "#fff !important",
        },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "8px 16px",
          "& .MuiButton-root": {
            fontWeight: 600,
          },
          "& .MuiButton-textPrimary": {
            color: "var(--color-accent-active)",
          },
        },
      },
    },
  },
});
